import { defineMessages } from 'react-intl';

export default defineMessages({
  company: {
    id: 'components.footer.company',
    defaultMessage: 'Company',
  },
  whatIsART: {
    id: 'components.footer.whatIsART',
    defaultMessage: 'What Is <strong>.ART</strong>',
  },
  community: {
    id: 'components.footer.community',
    defaultMessage: '<strong>.ART</strong> Community',
  },
  latestNews: {
    id: 'components.footer.latestNews',
    defaultMessage: 'Latest News',
  },
  contact: {
    id: 'components.footer.contact',
    defaultMessage: 'Contact',
  },
  support: {
    id: 'components.footer.support',
    defaultMessage: 'Support',
  },
  registrarPortal: {
    id: 'components.footer.registrarPortal',
    defaultMessage: 'Registrar portal',
  },
  registrars: {
    id: 'components.footer.registrars',
    defaultMessage: 'Registrars',
  },
  faq: {
    id: 'components.footer.faq',
    defaultMessage: 'Frequently Asked Questions',
  },
  logoAlt: {
    id: 'components.footer.logoAlt',
    defaultMessage: "The Art World's Exclusive Domain",
  },
  terms: {
    id: 'components.footer.terms',
    defaultMessage: 'Terms&amp;Conditions',
  },
  policies: {
    id: 'components.footer.policies',
    defaultMessage: 'Polices',
  },
  copyright: {
    id: 'components.footer.copyright',
    defaultMessage: 'UK Creative Limited 2017',
  },
});



// WEBPACK FOOTER //
// ./src/components/Footer/messages.js